<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    :pagination="false"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #colType="{text}">
      <span>{{ text.colType - 0 ? '自动' : '手动' }}</span>
    </template>
    <template #status="{text}">
      <a-popconfirm
        :title="`是否${text.status ? '禁用' : '启用'}?`"
        ok-text="确定"
        cancel-text="取消"
        @confirm="
          () =>
            col_activeCol_post(
              deletePeopleGoodsFlag({ ...text, status: text.status ? 0 : 1 })
            )
        "
        @cancel="cancel"
      >
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :checked="text.status - 0 ? true : false"
        />
      </a-popconfirm>
    </template>
    <template #peopleGoodsFlag="{text}">
      <a-popconfirm
        :title="`是否${text.peopleGoodsFlag - 0 ? '禁用' : '启用'}?`"
        ok-text="确定"
        cancel-text="取消"
        @confirm="
          () =>
            col_activeCol_post({
              ...text,
              peopleGoodsFlag: text.peopleGoodsFlag - 0 ? 0 : 1
            })
        "
        @cancel="cancel"
      >
        <a-switch
          checked-children="启用"
          un-checked-children="禁用"
          :checked="text.peopleGoodsFlag - 0 ? true : false"
        />
      </a-popconfirm>
    </template>
    <template #promotionFlag="{text}">
      <div>
        {{
          text.promotionFlag - 0 === 1
            ? '是'
            : text.promotionFlag - 0 === 0
            ? '否'
            : ''
        }}
      </div>
    </template>
    <template #deal="{text}">
      <div>
        <a-button
          type="link"
          style="color: #666666;"
          v-if="text.emailTriggerState - 0 === -1"
          >发送失败</a-button
        >
        <a-button
          v-if="text.emailTriggerState - 0 === -1"
          type="link"
          @click="reSend({ ...text, ...searchParams })"
          >重新发送</a-button
        >
        <a-button type="link" v-if="text.emailTriggerState - 0 === 1"
          >触发成功</a-button
        >
      </div>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs, ref } from 'vue'
export default {
  setup() {
    const columns = ref([
      {
        title: '编号',
        dataIndex: 'id',
        key: 'id',
        resizable: true,
        width: 100,
        align: 'center'
      },
      {
        title: '车2ID',
        dataIndex: 'cart2Id',
        key: 'cart2Id',
        width: 150,
        resizable: true,
        align: 'center'
      },
      {
        title: '用户邮箱',
        dataIndex: 'email',
        key: 'email',
        resizable: true,
        align: 'center',
        width: 180
      },
      {
        title: '创建时间',
        dataIndex: 'cart2GmtCreated',
        key: 'cart2GmtCreated',
        resizable: true,
        align: 'center',
        width: 200
      },
      {
        title: '邮件触发状态',
        slots: { customRender: 'deal' },
        align: 'center',
        width: 200
      }
    ])
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns,
      ...toRefs(inject('initState'))
    }
  }
}
</script>
